import { createInstance, type OptimizelyUserContext, type Client } from '@optimizely/optimizely-sdk';
import { create } from 'zustand';
import Cookie from 'js-cookie';
import { getENV } from '../utils';

interface OptimizelyStore {
    init: (pathname: string) => void;
    instance: Client | null;
    context: OptimizelyUserContext | null;
}
export const useOptimizely = create<OptimizelyStore>((set, get) => ({
    context: null,
    instance: null,
    init(pathname: string) {
        if (get().context) return;

        const instance = createInstance({
            logLevel: 4,
            sdkKey: getENV('NEXT_PUBLIC_OPTIMIZELY_SDK_KEY'),
        });

        instance?.onReady().then(() => {
            set(() => ({
                instance,
                context: instance.createUserContext(Cookie.get('x-petm-visitor-id'), {
                    Domain: window.location.host,
                    App: getENV('NEXT_PUBLIC_APP_NAME') === 'cpc' ? 'cart' : getENV('NEXT_PUBLIC_APP_NAME'),
                    Pathname: pathname,
                }),
            }));
        });
    },
}));
